/* @flow */

export type TabOption = 'activity' | 'note' | 'email' | 'text';

export const TAB_ACTIVITY = 'activity';
export const TAB_NOTE = 'note';
export const TAB_EMAIL = 'email';
export const TAB_TEXT = 'text';

export function isFormTabSelected(tab: TabOption | null): boolean {
    return tab !== null && (tab === TAB_NOTE || tab === TAB_ACTIVITY);
}
